import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ViewPdfComponent } from '../view-pdf/view-pdf.component';
import { ViewBatchNotesComponent } from '../view-batch-notes/view-batch-notes.component';
import { EditBatchComponent } from '../edit-batch/edit-batch.component';

@Injectable({
	providedIn: 'root'
})
export class MailDialogService {
	constructor(private dialogService: MatDialog) {}

	public viewMailFile(mailFileId: number): void {
		this.dialogService.open(ViewPdfComponent, {
			disableClose: true,
			minWidth: '900px',
			maxWidth: '100%',
			panelClass: 'default-modal',
			data: {
				mailFileId: mailFileId
			}
		});
	}

	public editBatchNotes(mailBatchId: number): void {
		this.dialogService.open(ViewBatchNotesComponent, {
			disableClose: false,
			minWidth: '400px',
			maxWidth: '99vw',
			panelClass: 'default-modal',
			data: {
				mailBatchId: mailBatchId
			}
		});
	}

	public editBatch(mailBatchId: number): void {
		this.dialogService.open(EditBatchComponent, {
			disableClose: false,
			minWidth: '400px',
			maxWidth: '99vw',
			panelClass: 'default-modal',
			data: {
				mailBatchId: mailBatchId
			}
		});
	}
}
